/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// Images
import team1 from "assets/images/avatar1.png";
import team2 from "assets/images/avatar2.png";
import team3 from "assets/images/avatar3.png";
import team4 from "assets/images/avatar4.png";
import team5 from "assets/images/avatar5.png";
import maria from "assets/images/avatar4.png";
import bruceMars from "assets/images/avatar7.png";
import ivana from "assets/images/avatar8.png";
import kal from "assets/images/avatar9.png";
import ivanaSquare from "assets/images/avatar10.png";
import ivancik from "assets/images/avatar2.png";

export default [
  {
    image: team1,
    name: "Abbie W",
    color: "info",
  },
  {
    image: team2,
    name: "Boris U",
    color: "info",
  },
  {
    image: team3,
    name: "Kay R",
    color: "info",
  },
  {
    image: team4,
    name: "Tom M",
    color: "info",
  },
  {
    image: team5,
    name: "Nicole N",
    color: "info",
  },
  {
    image: maria,
    name: "Maria P",
    color: "info",
  },
  {
    image: bruceMars,
    name: "Burce M",
    color: "info",
  },
  {
    image: ivana,
    name: "Sandra A",
    color: "info",
  },
  {
    image: kal,
    name: "Katty L",
    color: "info",
  },
  {
    image: ivanaSquare,
    name: "Emma Q",
    color: "info",
  },
  {
    image: ivancik,
    name: "Tao Q",
    color: "info",
  },
];
